// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorCont[data-v-8cda2d04] {\n  display: flex;\n}\n.errorCont .icon[data-v-8cda2d04] {\n  font-size: 50px;\n  color: #f5222d;\n  margin: 0 20px;\n}\n.errorCont .errorTips[data-v-8cda2d04] {\n  font-size: 16px;\n  padding: 0 20px 20px 0;\n  overflow: auto;\n}\n.errorCont .errorTips .error[data-v-8cda2d04] {\n  margin-bottom: 20px;\n}\n.errorCont .errorTips .contactUs[data-v-8cda2d04] {\n  white-space: pre;\n  max-height: 300px;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
